export default __webpack_public_path__ + "static/media/ServiceNow.fbf4e66c.svg";